module.exports = __webpack_public_path__ + "img/cherries.d2b68c2c.svg";